import React, { useState } from "react";
import { Button, Form, Drawer, Input, message, Switch } from "antd";
import axios from "axios";
import Cookies from "universal-cookie";
import Password from "antd/es/input/Password";
import { useTranslation } from "react-i18next";
import UploadDeleteFile from '../../../components/UploadDeleteFile';


const RecruitmentClientsForm = ({
  isModalOpen,
  setModal,
  editData,
  setEditData,
  getData,
  filter,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [isLoading, setLoading] = useState(false);
  const [newPassword, setNewPassword] = useState(false);
  const cookies = new Cookies();
  const token = cookies.get("token");

  const onClose = () => {
    setModal(false);
    setEditData(null);
  };

  const validFileExtension = ['.pdf'];
  const fetchUrl = '/api/attachment?name=';
  const uploadUrl = '/api/attachment/create';
  const deleteUrl = '/api/attachment/';
  const fileAccessUrl = 'https://cvparse.fra1.cdn.digitaloceanspaces.com/';
  const dataObj = {
    isUserSpecific: 1,
    isRoleSpecific: 0,
    isHead: 0,
  };
  dataObj.isUserSpecific === 1 && (dataObj.UserID ??= editData?.id);

  const handleUpdateUser = async (values, status = editData?.status) => {
    var data = JSON.stringify({
      ...(editData && { id: Number(editData?.id) }),
      ...(newPassword && { password: values?.newPassword }),
      ...(!editData && { password: values?.password }),
      name: values?.name,
      email: values?.email,
      isActive: values?.isActive,
    });
    setLoading(true);
    var config = {
      method: editData ? "put" : "post",
      url: "/api/recruitment",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        message.success(response.data.message);
        setLoading(false);
        onClose();
        getData(filter);
      })
      .catch(function (error) {
        message.error(error?.response?.data?.error);
        setLoading(false);
      });
  };

  return (
    <Drawer
      title={editData ? t("update") : t("create")}
      placement="right"
      onClose={onClose}
      open={isModalOpen}
    >
      {isModalOpen && (
        <Form
          layout="vertical"
          className="flex-gap-column"
          onFinish={handleUpdateUser}
          form={form}
          scrollToFirstError={true}
          initialValues={{
            name: editData?.name || "",
            email: editData?.email || "",
            password: editData?.password,
            newPassword: "",
            isActive: editData?.isActive || false,
          }}
        >
          <Form.Item
            name="name"
            label={t("name")}
            rules={[
              {
                required: true,
                message: "No Username provided",
              },
            ]}
          >
            <Input placeholder={"Enter name of the user"} />
          </Form.Item>
          <Form.Item
            name="email"
            label={t("email")}
            rules={[
              {
                required: true,
                message: "No Email provided",
              },
            ]}
          >
            <Input placeholder={"Enter email of the user"} />
          </Form.Item>
          {editData && (
            <div
              className="flex-small-gap small-margin"
              style={{ marginLeft: 0 }}
            >
              <Switch
                checked={newPassword}
                onChange={(checked) => {
                  setNewPassword(checked);
                  form.setFieldsValue("password", "");
                }}
                title={t("click_to_update_password")}
              />
              <div className="bold text-grey">{t("click_to_update_password")}</div>
            </div>
          )}
          {newPassword && (
            <Form.Item
              name="newPassword"
              label={t("new_password")}
              rules={[
                {
                  required: true,
                  message: "No New Password provided",
                },
              ]}
            >
              <Password placeholder={"Enter new password of the user"} />
            </Form.Item>
          )}
          {!editData && (
            <Form.Item
              name="password"
              label={t("password")}
              rules={[
                {
                  required: true,
                  message: "No Password provided",
                },
              ]}
            >
              <Password placeholder={"Enter password for the user"} />
            </Form.Item>
          )}
          <Form.Item
            name={"isActive"}
            label={t("account_status")}
            valuePropName={"checked"}
          >
            <Switch />
          </Form.Item>
          <div
            className="flex-at-end medium-margin-top"
            style={{ gridColumn: "1/3", gap: "1rem" }}
          >
            <Button className="" type="text" onClick={onClose}>
              {t("cancel")}
            </Button>
            <Button
              className=""
              type="primary"
              htmlType="submit"
              loading={isLoading}
            >
              {editData ? t("update") : t("create")}
            </Button>
          </div>

          {/* Manage Files Upload Section  */}
          {editData && !editData?.isHead && (
            <div className="manage-upload">
              <UploadDeleteFile
                fetchUrl={fetchUrl + 'Recruiter User Guide'}
                uploadUrl={uploadUrl}
                deleteUrl={deleteUrl}
                fileAccessUrl={fileAccessUrl}
                validFileExtension={validFileExtension}
                dataObj={dataObj}
                title='Recruiter User Guide'
              />
              <UploadDeleteFile
                fetchUrl={fetchUrl + 'Recruiter Work Process'}
                uploadUrl={uploadUrl}
                deleteUrl={deleteUrl}
                fileAccessUrl={fileAccessUrl}
                validFileExtension={validFileExtension}
                dataObj={dataObj}
                title='Recruiter Work Process'
              />
              <UploadDeleteFile
                fetchUrl={fetchUrl + 'Recruiter Communication Process'}
                uploadUrl={uploadUrl}
                deleteUrl={deleteUrl}
                fileAccessUrl={fileAccessUrl}
                validFileExtension={validFileExtension}
                dataObj={dataObj}
                title='Recruiter Communication Process'
              />
              <UploadDeleteFile
                fetchUrl={fetchUrl + 'Recruiter Targets'}
                uploadUrl={uploadUrl}
                deleteUrl={deleteUrl}
                fileAccessUrl={fileAccessUrl}
                validFileExtension={validFileExtension}
                dataObj={dataObj}
                title='Recruiter Targets'
              />
            </div>
          )}
        </Form>
      )}
    </Drawer>
  );
};

export default RecruitmentClientsForm;
